export const stripHtml = (html: string) => {
  const container = document.createElement('div');
  container.innerHTML = html
    .replaceAll('<br>', '\n')
    .replaceAll(/&nbsp;/g, ' ')
    .replaceAll('</p>', '</p>\n')
    .replaceAll('</div>', '</div>\n');

  const plainText = container.textContent || container.innerText || '';

  return plainText.trim();
};
